import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, recordRoute } from '../services/analytics/analyticsService';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view');
  }, [location.pathname]);

  // Route history (including the query string, which distinguishes e.g.
  // bestsellers from discounts on /products) for product click attribution.
  useEffect(() => {
    recordRoute(location.pathname, location.search);
  }, [location.pathname, location.search]);
}
